import script from "./DesktopNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopNavigation.vue?vue&type=style&index=0&id=88a32c0e&lang=less"

const __exports__ = script;

export default __exports__